import React, { ChangeEvent, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { Grid } from '@mui/material';
import {
  AcceptedAmico,
  Add,
  BasicModal,
  BasicTable,
  CardComponent,
  Chip,
  EmptyAmico1,
  InProgressAmico1,
  MitigatedAmico,
  NoComplianceAssurances,
  PageTitleAndSubTitle,
  PlannedAmico,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import RiskRegisterConstants from '../../core-utils/messages/RiskRegisterConstants';
import Snackbar from '../../_components/atoms/Snackbar';
import { pageScrollDown } from '../SummaryPage';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import {
  CircularLoader,
  Download,
  Typography,
} from '@HomaHealth/ui-component-library';
import AddRiskModal from '../../_components/organisms/AddRiskModalOpen';
import { useStores } from '../../stores';
import properties from '../../core-utils/properties';
import axios from 'axios';
import {
  cellStyles1,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  formatAcceptedRisks,
  formatInProgressRisks,
  formatMitigatedRisks,
  formatPlannedRisks,
  formatRiskTable,
  getReportName,
} from '../../core-utils/helper-utils/riskRegisterHelper';
import TabSelection from '../../_components/molecules/TabSelection';
import AcknowledgeRiskModal from '../../_components/organisms/AcknowledgeRiskModal';
import RiskDetailsWindow from '../../_components/organisms/RiskDetailsWindow';
import { handleDownloadReport } from '../../core-utils/helper-utils/contractReportHelper';
import { useNavigate } from 'react-router-dom';
import {
  GAG_CLAUSE_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  INTER_CONTRACT_REPORT,
} from '../../core-utils/routes';
import FeatureScreenAccess from '../../_components/organisms/FeatureScreenAccess';
import { isFeatureAccessible } from '../../core-utils/helper-utils/userAccess';

export interface RiskCounts {
  new: number;
  upcoming: number;
  inProgress: number;
  planned: number;
  accepted: number;
  mitigated: number;
}

const RiskRegistepage = observer(() => {
  //Styles
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
      width: '1422px',
    },
    tabs: {
      display: 'flex',
      flexDirection: 'column',
      gap: '25px',
      marginTop: '25px',
    },
  });
  const { classes } = useStyles();

  //Constants
  const navigate = useNavigate();
  const messages = RiskRegisterConstants.MAIN_PAGE;
  const [tabList] = useState<string[]>(messages.TAB_LIST);
  const NEW_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'ID',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Insight',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Impact',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Date Recorded',
      cellStyles: cellStyles1,
      align: 'left',
      width: '300px',
    },
    {
      name: 'Priority',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
    {
      name: 'Status',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
    {
      name: '',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Actions',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
  ];
  const INPROGRESS_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'ID',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Insight',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Task',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Impact',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Start Date',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Priority',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
    {
      name: 'Status',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
  ];
  const PLANNED_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'ID',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Insight',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Cause for Delaying Action',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Planned Task',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Planned For',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Priority',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
    {
      name: '',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
  ];
  const ACCEPTED_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'ID',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Title',
      cellStyles: cellStyles1,
      align: 'left',
      width: '400px',
      showEllipsis: true,
      ellipsisWidth: '350px',
    },
    {
      name: 'Reason For Acceptance',
      cellStyles: cellStyles1,
      align: 'left',
      width: '400px',
      showEllipsis: true,
      ellipsisWidth: '350px',
    },
    {
      name: 'Impact',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Priority',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
  ];
  const MITIGATED_RISK_TABLE_COLUMNS: Columns[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'ID',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Title',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Outcome Of Activity',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
      showEllipsis: true,
      ellipsisWidth: '250px',
    },
    {
      name: 'Impact',
      cellStyles: cellStyles1,
      align: 'left',
      width: '200px',
    },
    {
      name: 'Start Date',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
    {
      name: 'Completion Date',
      cellStyles: cellStyles1,
      align: 'left',
      width: '250px',
    },
  ];

  //Stores
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const userAccess = loginPageStore.userResponse;
  const combinedScreens = Array.from(
    new Set([
      ...(userAccess.careNavigationScreens || []),
      ...(userAccess.complianceAssuranceScreens || []),
      ...(userAccess.riskManagementScreens || []),
    ]),
  );

  //States
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [selectedRisk, setSelectedRisk] = useState<any>(null);
  const [selectedActivity, setSelectedActivity] = useState<any>(null);
  const [riskCounts, setRiskCounts] = useState<RiskCounts>({
    new: 0,
    upcoming: 0,
    inProgress: 0,
    planned: 0,
    accepted: 0,
    mitigated: 0,
  });
  const [newRiskModalOpen, setNewRiskModalOpen] = useState<boolean>(false);
  const [
    acknowledgeRiskModalOpen,
    setAcknowledgeRiskModalOpen,
  ] = useState<boolean>(false);
  const [riskDetailsWindowOpen, setRiskDetailsWindowOpen] = useState<boolean>(
    false,
  );
  const [
    activityDetailsWindowOpen,
    setActivityDetailsWindowOpen,
  ] = useState<boolean>(false);
  const [selectedRiskId, setSelectedRiskId] = useState<string>('');
  const [deletePopUpOpen, setDeletePopUpOpen] = useState<boolean>(false);

  //New & Upcoming Risk Table States
  const [newRiskTableloading, setNewRiskTableLoading] = useState<boolean>(
    false,
  );
  const [newRiskTableData, setNewRiskTableData] = useState<any>([]);
  const [newRiskTablePageNumber, setNewRiskTablePageNumber] = useState<number>(
    1,
  );
  const [tablePageSize] = useState<number>(5);
  const [newRiskTableTotalPages, setNewRiskTableTotalPages] = useState<number>(
    0,
  );

  //In Progress Risk Table States
  const [
    inProgressRiskTableloading,
    setInProgressRiskTableLoading,
  ] = useState<boolean>(false);
  const [inProgressRiskTableData, setInProgressRiskTableData] = useState<any>(
    [],
  );
  const [
    inProgressRiskTablePageNumber,
    setInProgressRiskTablePageNumber,
  ] = useState<number>(1);
  const [
    inProgressRiskTableTotalPages,
    setInProgressRiskTableTotalPages,
  ] = useState<number>(0);

  //Planned Risk Table States
  const [
    plannedRiskTableloading,
    setPlannedRiskTableLoading,
  ] = useState<boolean>(false);
  const [plannedRiskTableData, setPlannedRiskTableData] = useState<any>([]);
  const [
    plannedRiskTablePageNumber,
    setPlannedRiskTablePageNumber,
  ] = useState<number>(1);
  const [
    plannedRiskTableTotalPages,
    setPlannedRiskTableTotalPages,
  ] = useState<number>(0);

  //Mitigated Risk Table States
  const [
    mitigatedRiskTableloading,
    setMitigatedRiskTableLoading,
  ] = useState<boolean>(false);
  const [mitigatedRiskTableData, setMitigatedRiskTableData] = useState<any>([]);
  const [
    mitigatedRiskTablePageNumber,
    setMitigatedRiskTablePageNumber,
  ] = useState<number>(1);
  const [
    mitigatedRiskTableTotalPages,
    setMitigatedRiskTableTotalPages,
  ] = useState<number>(0);

  //Accepted Risk Table
  const [
    acceptedRiskTableloading,
    setAcceptedRiskTableLoading,
  ] = useState<boolean>(false);
  const [acceptedRiskTableData, setAcceptedRiskTableData] = useState<any>([]);
  const [
    acceptedRiskTablePageNumber,
    setAcceptedRiskTablePageNumber,
  ] = useState<number>(1);
  const [
    acceptedRiskTableTotalPages,
    setAcceptedRiskTableTotalPages,
  ] = useState<number>(0);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //Functions
  const handleAction = (risk: any) => {
    setSelectedRisk(risk);
    setAcknowledgeRiskModalOpen(true);
  };

  const handleAcknowledgeAction = async (risk: any) => {
    const data = {
      risk_id: risk?._id,
      status: 'Accepted',
    };
    await handleUpdateRisk(data);
    handleOpenSnackBar('Insights has been acknowledged', 'success', 6000);
  };

  const handleRiskClick = (risk: any) => {
    setSelectedRisk(risk);
    setRiskDetailsWindowOpen(true);
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  const handleActivityClick = (act: any) => {
    setSelectedActivity(act);
    setActivityDetailsWindowOpen(true);
  };

  const handleBack = () => {
    setActivityDetailsWindowOpen(false);
  };

  const getTabsContent = () => {
    switch (tabList[selectedTabIndex]) {
      case 'New Items & Active Plans':
        return <NewAndUpcomingRisk />;
      case 'Queued for Action':
        return <PlannedRisk />;
      case 'Completed Items':
        return <MitigatedAndAcceptedRisk />;
      default:
        return <></>;
    }
  };

  const handleNavigate = (
    contract: any,
    report: any,
    compare_agreement_id: any,
    handleOpenSnackBar: any,
  ) => {
    let path = '';
    switch (report) {
      case 'Gag Clause Compliance Check':
        path = GAG_CLAUSE_REPORT;
        break;
      case 'Provision Favorability Check':
        handleDownloadReport(
          'provisionMatrixReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          handleOpenSnackBar,
        );
        return;
      case 'Compensation Transparency Check':
        path = COMPENSATION_TRANSPARENCY_REPORT;
        break;
      case 'Inter-Contract Compliance Stop Loss and ASA':
      case 'Gap Analysis Check Plan Document and PBM':
      case 'Gap Analysis Check Plan Document and ASA':
        path = INTER_CONTRACT_REPORT;
        break;
      case 'Commercial Evaluation':
        handleDownloadReport(
          'feeEvaluationReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          handleOpenSnackBar,
        );
        return;
      default:
        return;
    }
    navigate(path, {
      state: {
        reportName: getReportName(report),
        document: `${contract?.health_care_partner_id?.health_care_partner} ${contract?.health_care_partner_id?.service_agreement_id?.service_agreement_name} Service Agreement`,
        healthcarePartner:
          contract?.health_care_partner_id?.health_care_partner,
        contract:
          contract?.health_care_partner_id?.service_agreement_id
            ?.service_agreement_name,
        contractId: contract._id,
        isContract: true,
        isReportsTab: true,
        compareId: compare_agreement_id?._id,
      },
    });
  };

  const handleMenuItem = (index: number, item: any, event: any, rowId: any) => {
    let riskId = '';
    switch (rowId) {
      case 'newRisk':
        riskId = newRiskTableData[index][0];
        break;
      case 'inProgressRisk':
        riskId = inProgressRiskTableData[index][0];
        break;
      case 'plannedRisk':
        riskId = plannedRiskTableData[index][0];
        break;
      case 'mitigatedRisk':
        riskId = mitigatedRiskTableData[index][0];
        break;
      case 'acceptedRisk':
        riskId = acceptedRiskTableData[index][0];
        break;
      default:
        break;
    }
    switch (item) {
      case 'Delete':
        setSelectedRiskId(riskId);
        setDeletePopUpOpen(true);
        break;
    }
  };

  const deleteRisk = async () => {
    handleOpenSnackBar('Insight deletion in progress', 'info', 2000);
    const data = {
      risk_id: selectedRiskId,
      deleted: true,
    };
    await handleUpdateRisk(data);
    handleOpenSnackBar('Insight has been deleted', 'success', 6000);
  };

  //Apis
  const handleDownload = async () => {
    const reportName = getReportName(selectedRisk.source_report);
    let reportType = '';
    if (
      selectedRisk?.vendor_type?.includes(
        'Administrative Services Only (ASO) Provider',
      ) &&
      selectedRisk?.vendor_type?.includes('Stop-Loss Insurance Provider')
    ) {
      reportType = 'asa-stoploss';
    }
    handleDownloadReport(
      reportName,
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
      selectedRisk?.contract_id?._id,
      handleOpenSnackBar,
      employerGroupStore.employerGroupResponseData.eg_nid[0],
      selectedRisk?.compare_agreement_id?._id,
      reportType,
    );
  };

  const handleAddRisk = async (data: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'files') {
        continue;
      } // handle files separately below

      const value = data[key];

      if (Array.isArray(value)) {
        if (value.length && typeof value[0] === 'object') {
          // For arrays of objects like `activity`
          formData.append(key, JSON.stringify(value));
        } else {
          // For arrays of strings like `impact`, `owner`
          value.forEach((item: any, index: number) => {
            formData.append(`${key}[${index}]`, item);
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // In case any single object sneaks in
        formData.append(key, JSON.stringify(value));
      } else if (value !== '') {
        formData.append(key, value); // Only append non-empty values
      }
    }
    formData.append(
      'eg_nid',
      // 'crane_nxt_1742408999728',
      employerGroupStore.employerGroupResponseData.eg_nid[0],
    );
    formData.append(
      'employer',
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
    );
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach((file: File) => {
        formData.append('files', file);
      });
    }
    await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.addRisk,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    getNewAndUpcomingRisks();
    getInProgressRisks();
    getPlannedRisks();
    getMitigatedRisks();
    getAcceptedRisks();
  };

  const handleUpdateRisk = async (data: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'files') {
        continue;
      } // handle files separately below

      const value = data[key];

      if (Array.isArray(value)) {
        if (value.length && typeof value[0] === 'object') {
          // For arrays of objects like `activity`
          formData.append(key, JSON.stringify(value));
        } else {
          // For arrays of strings like `impact`, `owner`
          value.forEach((item: any, index: number) => {
            formData.append(`${key}[${index}]`, item);
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // In case any single object sneaks in
        formData.append(key, JSON.stringify(value));
      } else if (value !== '') {
        formData.append(key, value); // Only append non-empty values
      }
    }
    formData.append(
      'eg_nid',
      // 'crane_nxt_1742408999728',
      employerGroupStore.employerGroupResponseData.eg_nid[0],
    );
    formData.append(
      'employer',
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
    );
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach((file: File) => {
        formData.append('files', file);
      });
    }
    await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.updateRisk,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    getNewAndUpcomingRisks();
    getInProgressRisks();
    getPlannedRisks();
    getMitigatedRisks();
    getAcceptedRisks();
  };

  const getRisks = async (
    status: any,
    pageNumber: number,
    is_current?: boolean,
  ) => {
    return await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.getRisk,
      {
        // eg_nid: 'crane_nxt_1742408999728',
        eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
        page: pageNumber,
        limit: tablePageSize,
        status: status,
        is_current,
      },
    );
  };

  const getNewAndUpcomingRisks = async () => {
    const isPlannedForCurrentQuarter = (plannedQuarter: string): boolean => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
      const currentQuarterLabel = `Q${currentQuarter} - ${currentYear}`;

      if (!plannedQuarter) {
        return false;
      }

      return (
        plannedQuarter === 'Current Quarter' ||
        plannedQuarter === currentQuarterLabel ||
        plannedQuarter === currentYear.toString()
      );
    };
    const risksData = await getRisks(
      ['New', 'Planned'],
      newRiskTablePageNumber,
      true,
    );
    const risks = risksData.data.data.risks;
    const riskCounts = risksData.data?.data?.totalFlattenedCount;
    setRiskCounts((prev) => ({
      ...prev,
      new: riskCounts['New'] ?? 0,
      upcoming: riskCounts['Planned'] ?? 0,
    }));
    const newRiskItems = risks.filter((r: any) => r.risk_status === 'New');
    const upcomingRiskItems = risks.filter(
      (r: any) =>
        r.risk_status === 'Planned' &&
        isPlannedForCurrentQuarter(r.planned_quarter),
    );
    const formattedNewRisks = formatRiskTable(
      [...newRiskItems, ...upcomingRiskItems],
      handleRiskClick,
      handleAction,
      handleAcknowledgeAction,
    );
    setNewRiskTableData(formattedNewRisks);
    setNewRiskTableTotalPages(Math.ceil(risksData.data?.data?.totalPages));
  };

  const getInProgressRisks = async () => {
    const risksData = await getRisks(
      ['In Progress'],
      inProgressRiskTablePageNumber,
    );
    const formattedInProgressRiskTableData = formatInProgressRisks(
      risksData?.data?.data?.risks,
      handleRiskClick,
    );
    setInProgressRiskTableData(formattedInProgressRiskTableData);
    setInProgressRiskTableTotalPages(
      Math.ceil(risksData.data?.data?.totalPages),
    );
    setRiskCounts((prev) => ({
      ...prev,
      inProgress:
        risksData?.data?.data?.totalFlattenedCount['In Progress'] ?? 0,
    }));
  };

  const getPlannedRisks = async () => {
    const risksData = await getRisks(['Planned'], plannedRiskTablePageNumber);
    const formattedPlannedRiskTableData = formatPlannedRisks(
      risksData?.data?.data?.risks,
      handleAction,
    );
    setPlannedRiskTableData(formattedPlannedRiskTableData);
    setPlannedRiskTableTotalPages(Math.ceil(risksData.data?.data?.totalPages));
    setRiskCounts((prev) => ({
      ...prev,
      planned: risksData?.data?.data?.totalFlattenedCount['Planned'] ?? 0,
    }));
  };

  const getMitigatedRisks = async () => {
    const risksData = await getRisks(
      ['Mitigated'],
      mitigatedRiskTablePageNumber,
    );
    const formattedMitigatedRiskTableData = await formatMitigatedRisks(
      risksData?.data?.data?.risks,
      handleRiskClick,
    );

    setMitigatedRiskTableData(formattedMitigatedRiskTableData);
    setMitigatedRiskTableTotalPages(
      Math.ceil(risksData.data?.data?.totalPages),
    );
    setRiskCounts((prev) => ({
      ...prev,
      mitigated: risksData?.data?.data?.totalFlattenedCount['Mitigated'] ?? 0,
    }));
  };

  const getAcceptedRisks = async () => {
    const risksData = await getRisks(['Accepted'], acceptedRiskTablePageNumber);
    const formattedAcceptedRiskTableData = formatAcceptedRisks(
      risksData?.data?.data?.risks,
      handleRiskClick,
    );
    setAcceptedRiskTableData(formattedAcceptedRiskTableData);
    setAcceptedRiskTableTotalPages(Math.ceil(risksData.data?.data?.totalPages));
    setRiskCounts((prev) => ({
      ...prev,
      accepted: risksData?.data?.data?.totalFlattenedCount['Accepted'] ?? 0,
    }));
  };

  //UseEffects
  useEffect(() => {
    const fetchRisks = async () => {
      if (!isFeatureAccessible('RISK_REGISTER', combinedScreens, userAccess)) {
        return;
      }
      setNewRiskTableLoading(true);
      await Promise.all([getNewAndUpcomingRisks()]);
      setNewRiskTableLoading(false);
    };
    fetchRisks();
  }, [newRiskTablePageNumber]);

  useEffect(() => {
    const fetchRisks = async () => {
      if (!isFeatureAccessible('RISK_REGISTER', combinedScreens, userAccess)) {
        return;
      }
      setInProgressRiskTableLoading(true);
      await Promise.all([getInProgressRisks()]);
      setInProgressRiskTableLoading(false);
    };
    fetchRisks();
  }, [inProgressRiskTablePageNumber]);

  useEffect(() => {
    const fetchRisks = async () => {
      if (!isFeatureAccessible('RISK_REGISTER', combinedScreens, userAccess)) {
        return;
      }
      setPlannedRiskTableLoading(true);
      await Promise.all([getPlannedRisks()]);
      setPlannedRiskTableLoading(false);
    };
    fetchRisks();
  }, [plannedRiskTablePageNumber]);

  useEffect(() => {
    const fetchRisks = async () => {
      if (!isFeatureAccessible('RISK_REGISTER', combinedScreens, userAccess)) {
        return;
      }
      setMitigatedRiskTableLoading(true);
      await Promise.all([getMitigatedRisks()]);
      setMitigatedRiskTableLoading(false);
    };
    fetchRisks();
  }, [mitigatedRiskTablePageNumber]);

  useEffect(() => {
    const fetchRisks = async () => {
      if (!isFeatureAccessible('RISK_REGISTER', combinedScreens, userAccess)) {
        return;
      }
      setAcceptedRiskTableLoading(true);
      await Promise.all([getAcceptedRisks()]);
      setAcceptedRiskTableLoading(false);
    };
    fetchRisks();
  }, [acceptedRiskTablePageNumber]);

  //Components
  const NewAndUpcomingRisk = () => {
    return (
      <>
        <CardComponent
          title={messages.TABLE1_TITLE}
          chip={
            <Chip
              height="27px"
              borderRadius="4px"
              padding="5px 10px"
              label={
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  <Typography
                    style={{
                      fontSize: '16px',
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    }}
                  >
                    {riskCounts?.new}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    New
                  </Typography>
                  <Grid
                    style={{
                      width: '1px',
                      height: '20px',
                      background: patientAccessTheme.palette.grey[300],
                      borderRadius: '6px',
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: '16px',
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    }}
                  >
                    {riskCounts?.upcoming}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    Upcoming
                  </Typography>
                </Grid>
              }
              backgroundColor={patientAccessTheme.palette.background.default}
            />
          }
          body={
            <Grid style={{ marginTop: '20px' }}>
              {newRiskTableloading ? (
                <CircularLoader />
              ) : newRiskTableData?.length > 0 ? (
                <BasicTable
                  isMenuAvailable={true}
                  handleCellMenuItem={handleMenuItem}
                  menuOptions={messages.TABLE_MENU}
                  rowId={'newRisk'}
                  displayType="row"
                  columns={NEW_RISK_TABLE_COLUMNS}
                  rowsData={newRiskTableData}
                  hideColumnIndex={0}
                  showPagination={true}
                  pageCount={newRiskTableTotalPages}
                  pageNumber={newRiskTablePageNumber}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => {
                    setNewRiskTablePageNumber(page);
                  }}
                />
              ) : (
                <NoComplianceAssurances
                  isImageOnTop={true}
                  title={messages.NO_NEW_RISK}
                  subTitle={messages.NO_NEW_RISK_SUB}
                  image={<EmptyAmico1 />}
                  buttonLabel={messages.ADD_NEW_RISK}
                  handleOnclick={() => {
                    setNewRiskModalOpen(true);
                  }}
                  startIcon={<Add />}
                  rootStyles={{
                    border: '0px',
                    background: '',
                    padding: '20px',
                    height: '350px',
                  }}
                  titleFont="18px"
                  subTitleFont="14px"
                  subTitleMargin="0px"
                  buttonWidth="240px"
                />
              )}
            </Grid>
          }
          tooltip={messages.TABLE1_TITLE}
        />
        <CardComponent
          title={messages.TABLE2_TITLE}
          chip={
            <Chip
              height="27px"
              borderRadius="4px"
              padding="5px 10px"
              label={
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  <Typography
                    style={{
                      fontSize: '16px',
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    }}
                  >
                    {riskCounts?.inProgress}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    In Progress
                  </Typography>
                </Grid>
              }
              backgroundColor={patientAccessTheme.palette.background.default}
            />
          }
          body={
            <Grid style={{ marginTop: '20px' }}>
              {inProgressRiskTableloading ? (
                <CircularLoader />
              ) : inProgressRiskTableData?.length > 0 ? (
                <BasicTable
                  isMenuAvailable={true}
                  handleCellMenuItem={handleMenuItem}
                  menuOptions={messages.TABLE_MENU}
                  rowId={'inProgressRisk'}
                  displayType="row"
                  columns={INPROGRESS_RISK_TABLE_COLUMNS}
                  rowsData={inProgressRiskTableData}
                  hideColumnIndex={0}
                  showPagination={true}
                  pageCount={inProgressRiskTableTotalPages}
                  pageNumber={inProgressRiskTablePageNumber}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => {
                    setInProgressRiskTablePageNumber(page);
                  }}
                />
              ) : (
                <NoComplianceAssurances
                  isImageOnTop={true}
                  title={messages.NO_INPROGRESS_RISK}
                  subTitle={messages.NO_INPROGRESS_RISK_SUB}
                  image={<InProgressAmico1 />}
                  buttonLabel={messages.ADD_NEW_RISK_MITIGATION}
                  handleOnclick={() => {
                    setNewRiskModalOpen(true);
                  }}
                  startIcon={<Add />}
                  rootStyles={{
                    border: '0px',
                    background: '',
                    padding: '20px',
                    height: '350px',
                  }}
                  titleFont="18px"
                  subTitleFont="14px"
                  subTitleMargin="0px"
                  buttonWidth="240px"
                />
              )}
            </Grid>
          }
          tooltip={messages.NO_INPROGRESS_RISK_SUB}
        />
      </>
    );
  };

  const PlannedRisk = () => {
    return (
      <CardComponent
        title={messages.TABLE3_TITLE}
        chip={
          <Chip
            height="27px"
            borderRadius="4px"
            padding="5px 10px"
            label={
              <Grid
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                <Typography
                  style={{
                    fontSize: '16px',
                    color: patientAccessTheme.palette.text.highemphasis,
                    fontWeight: 600,
                  }}
                >
                  {riskCounts?.planned}
                </Typography>
                <Typography
                  style={{
                    fontSize: '12px',
                    color: patientAccessTheme.palette.text.mediumemphasis,
                  }}
                >
                  Planned
                </Typography>
              </Grid>
            }
            backgroundColor={patientAccessTheme.palette.background.default}
          />
        }
        body={
          <Grid style={{ marginTop: '20px' }}>
            {plannedRiskTableloading ? (
              <CircularLoader />
            ) : plannedRiskTableData?.length > 0 ? (
              <BasicTable
                isMenuAvailable={true}
                handleCellMenuItem={handleMenuItem}
                menuOptions={messages.TABLE_MENU}
                rowId={'plannedRisk'}
                displayType="row"
                columns={PLANNED_RISK_TABLE_COLUMNS}
                rowsData={plannedRiskTableData}
                hideColumnIndex={0}
                showPagination={true}
                pageCount={plannedRiskTableTotalPages}
                pageNumber={plannedRiskTablePageNumber}
                handlePagination={(
                  event: ChangeEvent<unknown>,
                  page: number,
                ) => {
                  setPlannedRiskTablePageNumber(page);
                }}
              />
            ) : (
              <NoComplianceAssurances
                isImageOnTop={true}
                title={messages.NO_RISK_PLANNED}
                subTitle={messages.NO_RISK_PLANNED_SUB}
                image={<PlannedAmico />}
                rootStyles={{
                  border: '0px',
                  background: '',
                  padding: '20px',
                  height: '350px',
                }}
                titleFont="18px"
                subTitleFont="14px"
                subTitleMargin="0px"
                handleOnclick={() => {}}
                hideButton={true}
              />
            )}
          </Grid>
        }
        tooltip={messages.NO_RISK_PLANNED_SUB}
      />
    );
  };

  const MitigatedAndAcceptedRisk = () => {
    return (
      <>
        <CardComponent
          title={messages.TABLE4_TITLE}
          chip={
            <Chip
              height="27px"
              borderRadius="4px"
              padding="5px 10px"
              label={
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  <Typography
                    style={{
                      fontSize: '16px',
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    }}
                  >
                    {riskCounts?.mitigated}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    Resolved
                  </Typography>
                </Grid>
              }
              backgroundColor={patientAccessTheme.palette.background.default}
            />
          }
          body={
            <Grid style={{ marginTop: '20px' }}>
              {mitigatedRiskTableloading ? (
                <CircularLoader />
              ) : mitigatedRiskTableData?.length > 0 ? (
                <BasicTable
                  isMenuAvailable={true}
                  handleCellMenuItem={handleMenuItem}
                  menuOptions={messages.TABLE_MENU}
                  rowId={'mitigatedRisk'}
                  displayType="row"
                  columns={MITIGATED_RISK_TABLE_COLUMNS}
                  rowsData={mitigatedRiskTableData}
                  hideColumnIndex={0}
                  showPagination={true}
                  pageCount={mitigatedRiskTableTotalPages}
                  pageNumber={mitigatedRiskTablePageNumber}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => {
                    setMitigatedRiskTablePageNumber(page);
                  }}
                />
              ) : (
                <NoComplianceAssurances
                  isImageOnTop={true}
                  title={messages.NO_RISK_MITIGATED}
                  subTitle={messages.NO_RISK_MITIGATED_SUB}
                  image={<MitigatedAmico />}
                  handleOnclick={() => {}}
                  rootStyles={{
                    border: '0px',
                    background: '',
                    padding: '20px',
                    height: '350px',
                  }}
                  titleFont="18px"
                  subTitleFont="14px"
                  subTitleMargin="0px"
                  hideButton={true}
                />
              )}
            </Grid>
          }
          tooltip={messages.NO_RISK_MITIGATED_SUB}
        />
        <CardComponent
          title={messages.TABLE_5_TITLE}
          chip={
            <Chip
              height="27px"
              borderRadius="4px"
              padding="5px 10px"
              label={
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  <Typography
                    style={{
                      fontSize: '16px',
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    }}
                  >
                    {riskCounts?.accepted}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '12px',
                      color: patientAccessTheme.palette.text.mediumemphasis,
                    }}
                  >
                    Acknowledged
                  </Typography>
                </Grid>
              }
              backgroundColor={patientAccessTheme.palette.background.default}
            />
          }
          body={
            <Grid style={{ marginTop: '20px' }}>
              {acceptedRiskTableloading ? (
                <CircularLoader />
              ) : acceptedRiskTableData?.length > 0 ? (
                <BasicTable
                  isMenuAvailable={true}
                  handleCellMenuItem={handleMenuItem}
                  menuOptions={messages.TABLE_MENU}
                  rowId={'acceptedRisk'}
                  displayType="row"
                  columns={ACCEPTED_RISK_TABLE_COLUMNS}
                  rowsData={acceptedRiskTableData}
                  hideColumnIndex={0}
                  showPagination={true}
                  pageCount={acceptedRiskTableTotalPages}
                  pageNumber={acceptedRiskTablePageNumber}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => {
                    setAcceptedRiskTablePageNumber(page);
                  }}
                />
              ) : (
                <NoComplianceAssurances
                  isImageOnTop={true}
                  title={messages.NO_RISK_ACCEPTED}
                  subTitle={messages.NO_RISK_ACCEPTED_SUB}
                  image={<AcceptedAmico />}
                  handleOnclick={() => {}}
                  rootStyles={{
                    border: '0px',
                    background: '',
                    padding: '20px',
                    height: '350px',
                  }}
                  titleFont="18px"
                  subTitleFont="14px"
                  subTitleMargin="0px"
                  hideButton={true}
                />
              )}
            </Grid>
          }
          tooltip={messages.NO_RISK_ACCEPTED_SUB}
        />
      </>
    );
  };

  return (
    <>
      <div>
        <Grid container className={classes.root}>
          <FeatureScreenAccess
            noAccess={isFeatureAccessible(
              'RISK_REGISTER',
              combinedScreens,
              userAccess,
            )}
          >
            <Grid
              style={{
                marginBottom: '36px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={RiskRegisterConstants.MAIN_PAGE.TITLE}
                subTitle={''}
                subTitleStyles={{ width: '90%' }}
                customButton={true}
                customButtonText={['Add New Insight / Strategy', 'Export']}
                customButtonVariant={['contained', 'outlined', 'text']}
                customButtonStartIcon={[
                  <Add style={{ color: 'white' }} />,
                  <Download />,
                ]}
                customButtonClick={[
                  () => {
                    setNewRiskModalOpen(true);
                  },
                  () => {},
                ]}
                customButtonWidth={['240px', '150px']}
              />
            </Grid>
            <TabSelection
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={handleSelectedIndex}
              tabList={tabList}
              margin="0px"
            />
            <Grid className={classes.tabs}>{getTabsContent()}</Grid>
          </FeatureScreenAccess>

          {riskDetailsWindowOpen && (
            <RiskDetailsWindow
              risk={selectedRisk}
              setDetailsWindowOpen={setRiskDetailsWindowOpen}
              handleSave={handleUpdateRisk}
              handleOpenSnackBar={handleOpenSnackBar}
              handleActivityClick={handleActivityClick}
              handleNavigate={handleNavigate}
            />
          )}
          {activityDetailsWindowOpen && (
            <RiskDetailsWindow
              risk={selectedRisk}
              activity={selectedActivity}
              setDetailsWindowOpen={setActivityDetailsWindowOpen}
              handleSave={handleUpdateRisk}
              handleOpenSnackBar={handleOpenSnackBar}
              isActivityWindow={true}
              handleBack={handleBack}
            />
          )}

          <div id="scroll-top-element"></div>
        </Grid>
        {pageScrollDown('scroll-top-element')}
      </div>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      {newRiskModalOpen && (
        <AddRiskModal
          open={newRiskModalOpen}
          setOpen={setNewRiskModalOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          handleSubmit={handleAddRisk}
          // eg_nid={'crane_nxt_1742408999728'}
          eg_nid={employerGroupStore.employerGroupResponseData.eg_nid[0]}
        />
      )}
      {acknowledgeRiskModalOpen && (
        <AcknowledgeRiskModal
          open={acknowledgeRiskModalOpen}
          setOpen={setAcknowledgeRiskModalOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          handleSubmit={handleUpdateRisk}
          risk={selectedRisk}
          handleDownload={handleDownload}
          // eg_nid={'crane_nxt_1742408999728'}
          handleNavigate={handleNavigate}
          eg_nid={employerGroupStore.employerGroupResponseData.eg_nid[0]}
        />
      )}
      {deletePopUpOpen && (
        <BasicModal
          open={deletePopUpOpen}
          title={messages.DELETE}
          body={
            <Typography
              fontSize="12px"
              lineHeight="17px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="0px 0px 15px 0px"
            >
              {messages.DELETE_DESC}
            </Typography>
          }
          cancelButtonLabel={messages.CANCEL}
          confirmButtonLabel={messages.CONFIRM}
          handleCancel={() => setDeletePopUpOpen(false)}
          handleConfirm={() => {
            deleteRisk();
            setDeletePopUpOpen(false);
          }}
          handleClose={() => setDeletePopUpOpen(false)}
        />
      )}
    </>
  );
});

export default RiskRegistepage;
